export default class OrderItemsTransformer {
  static transformForOrderItemsUpdate(order, itemsToRemoveIds = []) {
    if (!order) {
      return [];
    }

    const orderItems = order.items
      .filter(orderItem => !itemsToRemoveIds.includes(orderItem.id))
      .map(orderItem => {
        const item = {
          ...orderItem.attributes,
          unit_price: {
            [order.currencyId]: orderItem.unitPrice.value,
          },
          taxed_unit_price: {
            [order.currencyId]: orderItem.taxedUnitPrice.value,
          },
          price: {
            [order.currencyId]: orderItem.price.value,
          },
          taxed_price: {
            [order.currencyId]: orderItem.taxedPrice.value,
          },
          total_price: {
            [order.currencyId]: orderItem.totalPrice.value,
          },
          taxed_total_price: {
            [order.currencyId]: orderItem.taxedTotalPrice.value,
          },
        };

        if (item.product_id || item.product_variation_id) {
          item.name = null;
        }

        return item;
      });

    return orderItems;
  }
}
